import "./styles/Title.scss";
import { ReactNode } from "react";
import { useIsInDialog } from "@/features/dialog/hooks/useIsInDialog.tsx";

type Props = {
  id?: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  children: ReactNode;
  className?: string;
}

const Title = ({ id, level = 1, children, className, ...props }: Props) => {
  const { isInDialog } = useIsInDialog();

  const element = `h${ level }`;
  const TitleElement = element as keyof JSX.IntrinsicElements;

  const classes = [
    `ws-widgets-title`,
    `ws-widgets-title-${ element }`,
    isInDialog ? `ws-widgets-dialog-title` : ``,
    isInDialog ? `ws-widgets-title--dialog`: ``,
    isInDialog ? `ws-widgets-title-${ element }--dialog` : ``,
    className,
  ];

  return (
    <TitleElement
      id={ id }
      className={ classes.join(` `) }
      { ...props }
    >
      { children }
    </TitleElement>
  )
}

export default Title;
